<template>
<div class="center__div">
  <div v-if="pageReady">
    <vue-headful :title="site_title + ': ' + data.header" />
    <MainStickiedArticles />

    <!-- NEWS -->
    <div v-if="!isArticle">
      <!-- DATE -->
      <div class="news__date">
        <div>{{data.time | formatRusDateLong2}}</div>
      </div>
      <!-- ICON, NAME, AUTHOR, DATE -->
      <div class="news__articletitle">
        <!-- if article -->
        <template v-if="isArticle">
          <a :href="'?actions=division&ions='+data.division"> <img style="vertical-align: middle; padding-right: 5px;" :src="publicPath + 'div' + getCircleIcon(data.circle) +'.gif'"> </a>
        </template>
        <!-- if news -->
        <template v-else>
          <a :href="'?actions=news&category='+data.circle"> <img style="vertical-align: middle; padding-right: 5px;" :src="publicPath + 'div' + getCircleIcon(data.circle) +'.gif'"> </a>
        </template>
        <span>{{htmlDecode(data.header)}}</span> -
        <a :href="'mailto:'+data.email">{{htmlDecode(data.name)}}</a> |
        {{data.time | formatDateHours}}
      </div>
      <br>
      <!-- NEWS BODY -->
      <div class="article__body" v-html="fixBrs(fixRealmsMainPaths(data.body))"></div>
    </div>
    <!-- end of NEWS -->

    <!-- ARTICLE -->
    <div v-if="isArticle">
      <!-- article name  -->
      <div class="news__date">
        <div>{{data.header}}</div>
      </div>
      <div style="padding-top:5px;">
        Опубликовал: <a :href="'mailto:'+data.email">{{htmlDecode(data.name)}}</a>, {{data.time | formatDateHours}} [ {{data.time | formatDateNumeric}} ]
        <br>
        Раздел, ярус: <a :href="'/main/?actions=articles&ions='+data.division">{{getDivisionName(data.division)}}</a>,
        <a :href="'/main/?actions=articles&ions='+data.division+'&category='+data.circle">{{getCircleName(data.circle)}}</a>
        <br>
        Кол-во просмотров/прочтений: {{data.nview}}
        <br>
        <a class="article__statlink" :href="'#comments'">Кол-во комментариев: {{data.ncomments}}</a>
        <br>
        <a class="article__statlink">Рейтинг: {{ data.nvotes > 0 ? ( Number.isInteger(data.bal/data.nvotes) ? (data.bal/data.nvotes) : (data.bal/data.nvotes).toFixed(1)) : '...'}}/10, проголосовало {{data.nvotes}}</a>
        <br><br>
      </div>
      <div class="article__body" v-html="fixBrs(fixRealmsMainPaths(data.body))"></div>
    </div>
    <!-- end of ARTICLE -->

    <!-- NUMBER OF COMMENTS -->
    <div class="news__commentlink">
      <a :href="'#comments'">Комментарии ({{data.ncomments}})</a>
    </div>
    <div class="news__separator"></div>

    <!-- other articles
    <div class="news__date">
      Другие {{isArticle ? 'статьи' : 'новости'}} из этого раздела
    </div>
    <div style="padding: 4px 0 4px 0;">
      (другие статьи / новости)
    </div>
    <div class="news__separator"></div>
     end of other articles-->

    <!-- COMMENTS -->
    <div v-if="data.ncomments > 0">
      <div class="news__date">
        <div id="comments">Комментарии</div>
      </div>
      <div class="article__commentframe comment__frame" v-for="(comment, index) in data.comments">
        <!-- first row -->
        <div style="display: flex; padding-top: 2px; height: 22px; font-weight: bold;">
          <div style="display: flex; width: 134px; margin: 0 2px 0 2px;">
            <div class="comment__frame comment__align_vertical comment__woodbg" style="width: 24px; justify-content: center; margin-right: 2px;">#{{index+1}}</div>
            <div class="comment__frame comment__align_vertical" style="width: 100px; justify-content: center; overflow: hidden;"><a>{{comment.name}}</a>:</div>
          </div>
          <div class="comment__frame comment__align_vertical comment__woodbg" style="width: 100%; padding: 0 6px 0 6px; margin-right: 2px;">
            {{decodeHtml(comment.header)}}
          </div>
        </div>
        <!-- second row -->
        <div style="display: flex; margin: 2px; margin-left: 0px;">
          <div style="max-width: 134px; min-width: 134px; min-height: 190px; display: flex; align-items: center; flex-direction: column;">
            <div><b>{{getTitle(comment.mgroup)}}</b></div>
            <div style="padding-top: 1px;"><img :src="publicPath+'avatars/'+ (comment.avatar ? comment.avatar : 'Neverwinter Nights/nwn_male_01.gif')" /></div>
            <div style="font-size: 11px; text-align: center;">
              <div><i><a :href="'mailto:'+comment.email">E-mail</a> / <a :href='"icq:"+comment.icq_number'>ICQ</a></i></div>
              <div><i><a class="article__statlink" :href='"/main/?actions=stats&t=2&user="+comment.userid'>Новости: {{comment.n_news}}</a></i></div>
              <div><i><a class="article__statlink" :href='"/main/?actions=stats&t=3&user="+comment.userid'>Статьи: {{comment.n_articles}}</a></i></div>
              <div><i><a class="article__statlink">Комментарии: {{comment.n_comments}}</a></i></div>
            </div>
          </div>
          <div style="width: 100%; padding: 3px; font-size: 13px;" class="comment__frame" v-html="highlightQuotes(decodeHtml(fixRealmsMainPaths(comment.comment)))"></div>
        </div>
        <!-- third row -->
        <div style="display: flex; margin: 2px; height: 20px;">
          <div class="comment__frame comment__align_vertical comment__woodbg" style="justify-content: center; width: calc(60% - 1px); margin-right: 1px;"><b>Дата создания сообщения:</b></div>
          <div class="comment__frame comment__align_vertical" style="justify-content: center; width: calc(40% - 1px); margin-left: 1px;">
            <b>{{comment.time | formatDateHours}} [ {{comment.time | formatDateNumeric}} ]</b>
          </div>
        </div>
      </div>
      <div class="news__separator"></div>
    </div>
    <!-- end of comments -->

    <div class="news__date">
      <a class="article__statlink" href="/main/">На главную</a>
    </div>
  </div>
</div>
</template>


<script>
import MainStickiedArticles from './MainStickiedArticles'
//import FooterPermanent from './FooterPermanent'

export default {
  components: {
    MainStickiedArticles,
    //ForumSection,
    //FooterPermanent
  },
  data: function() {
    return {
      pageReady: false,
      isArticle: false,
      data: null,
    }
  },
  async created() {
    console.time("PageLoadTime");

    let response = null;

    // e.g. http://realms.test:8080/main/?actions=viewarticles&page=1
    if (this.$route.query.actions && this.$route.query.actions.toUpperCase() == 'VIEWARTICLES' && this.$route.query.page) {
      response = await fetch(this.getNodePath() + 'main/article/' + this.$route.query.page);
      this.isArticle = true;
    }
    // e.g. http://realms.test:8080/main/?actions=viewnews&page=496
    else if (this.$route.query.actions && this.$route.query.actions.toUpperCase() == 'VIEWNEWS' && this.$route.query.page) {
      response = await fetch(this.getNodePath() + 'main/news/' + this.$route.query.page);
      this.isArticle = false;
    }

    this.data = await response.json();
    this.removeRepeatingComments();
    this.pageReady = true;
    console.timeEnd("PageLoadTime");
  },
  methods: {
    // due to poor internet connection, people used to leave comments twice or more times
    // this function removes duplicates that immediately follow each other
    removeRepeatingComments() {
      this.data.comments = this.data.comments.filter((item, index, self) => {
        // Check if it's the first item, if so we should keep it
        if (index === 0) {
          return true;
        }

        // Get the previous item
        const prevItem = self[index - 1];

        // If the current comment and the author are same as the previous, filter out
        if (item.comment === prevItem.comment && item.name === prevItem.name) {
          return false;
        }

        // If they're different, keep the current item
        return true;
      });
    },
  }
}
</script>

<style lang="scss">
@import "../main-colors.scss";
@import "./MainNews.scss";
</style>
